import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import {
  CouponStatus,
  CouponStatusColor,
} from 'src/app/shared/models/constants/coupon-status';
import { CouponVip } from 'src/app/shared/models/dtos/responses/coupon-vip/coupon-vip';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-coupon-card-slim-vip',
  templateUrl: './coupon-card-slim-vip.component.html',
  styleUrls: ['./coupon-card-slim-vip.component.scss'],
})

/**
 * Coupon card slim alternative
 */
export class CouponCardSlimVipComponent implements OnInit, OnDestroy {
  @Input() coupon!: CouponVip;
  activeStatus = CouponStatus.ACTIVE;
  redeemedStatus = CouponStatus.REDEEMED;
  canceledStatus = CouponStatus.CANCELED;
  expiredStatus = CouponStatus.EXPIRED;
  labels = {
    discount: 'discount',
    issuedOn: 'issued-on',
    expiresOn: 'expires-on',
    coupon: 'coupon',
    copyCouponCode: 'copy-coupon-card-code',
    seeCoupon: 'see-coupon',
    reactivateCoupon: 'reactivate-coupon',
    requested: 'requested',
    active: 'active-coupon',
    expired: 'expired-coupon',
    error: 'backend-comm-error',
    codeCopied: 'code-copied',
    code: 'code',
    reseller: 'reseller',
  };
  RoutesKeys = RoutesKeys;
  private subsink = new Subscription();
  loading = false;
  language = '';

  /**
   * @constructor
   */
  constructor(
    readonly translationService: TranslationService,
    private readonly router: Router
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.language = this.translationService.getActiveLang();
    this.translationService.translateObject(this.labels);
  }

  /**
   * cleans up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * Get item color according to coupon status
   * @param {boolean} active
   * @return {string}
   */
  getStatusColor(active: boolean = false): string {
    return active ? CouponStatusColor.GREEN : CouponStatusColor.GRAY;
  }

  /**
   * On route to coupon details page
   */
  openCouponDetails() {
    this.router.navigate([RoutesKeys.COUPONS_VIP, this.coupon?.id]);
  }
}
